import { auth } from './FirebaseConfig';

const SYSTEM_UPDATES_API =
    'https://us-central1-etikaf-admin.cloudfunctions.net/getEtikafAdminSystemUpdates';

export const fetchPublishedSystemUpdates = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error('Sesi pentadbir tidak tersedia.');

    const idToken = await user.getIdToken();
    const response = await fetch(SYSTEM_UPDATES_API, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({}),
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload?.error || 'Feed kemas kini tidak tersedia.');
    return Array.isArray(payload.updates) ? payload.updates : [];
};
